"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EllipsisBox = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
exports.EllipsisBox = function (props) {
    var text = props.text, _a = props.correctLength, correctLength = _a === void 0 ? 30 : _a;
    if (text.length > correctLength) {
        return (react_1.default.createElement(core_1.Tooltip, { title: text },
            react_1.default.createElement(core_1.Box, null, text.substring(0, correctLength - 3) + '...')));
    }
    else {
        return react_1.default.createElement(react_1.default.Fragment, null, text);
    }
};
